/* eslint-disable  */
import React from 'react';
import PropTypes from 'prop-types';
import { useGetTheme } from '../../../../hooks/useGetTheme';
import s from '../../../../screens/staking/card-table/items/item.module.scss';
import ColumnTotalStakedAmountTitle from './title';

const ColumnTotalStakedAmount = ({ title, logoIcon, componentIcon, token, subIcons, usdPrice, isNew }) => {
  const colors = useGetTheme();
  const getTitleColor = () => ({ style: { color: colors.text } });
  return (
    <>
      <ColumnTotalStakedAmountTitle isMobile />
      <div className={s.col}>
        <div className={s.logoContainer}>
          { componentIcon ? componentIcon : <img className={s.logo} src={logoIcon} alt='' />}

          {subIcons && subIcons.length ? (
            <div className={s.subIcons}>
              {subIcons.map((subIcon) => (
                <a
                  href={subIcon.href}
                  target='_blank'
                  rel={'noopener noreferrer'}
                  key={subIcon.src}
                >
                  <img className={s.subIconsItem} src={subIcon.src} alt={subIcon.alt} />
                </a>
              ))}
            </div>
          ) : null}
        </div>
        <div className={s.stakeBalance}>
          <p className={s.topLine} {...getTitleColor()}>
            {title} {token}
          </p>
          {usdPrice ? <p className={s.bottomLine}>${usdPrice}</p> : null}
          {isNew ? <div className={s.stakeBalanceLabel}>New</div> : null}
        </div>
        <div />
      </div>
    </>
  );
};

ColumnTotalStakedAmount.propTypes = {
  title: PropTypes.string.isRequired,
  logoIcon: PropTypes.string.isRequired,
  token: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.number.isRequired]),
  subIcons: PropTypes.arrayOf(
    PropTypes.shape({
      src: PropTypes.string.isRequired,
      href: PropTypes.string,
      alt: PropTypes.string,
    }),
  ),
  usdPrice: PropTypes.string,
  isNew: PropTypes.bool,
};

export default ColumnTotalStakedAmount;
